import { render } from "./pricelabels.vue?vue&type=template&id=61a087d5"
import script from "./pricelabels.vue?vue&type=script&lang=js"
export * from "./pricelabels.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__